import axios from 'axios'
const token = '7QEKrgaJwAACLfCDMhlOiDbVQTnSeCsB@FbYazZgvI2c6jqvZkRMghJ5DIar1W6sq'
const baiduUrl = '/ocpcapi/api/uploadConvertData'
//广告主回传转化数据接口
export const sendConvertData = (conversionTypes) => {
    const data = {
        token,
        conversionTypes
    }
    return axios({
        method: "post",
        url: baiduUrl,
        headers: {
            "Content-Type": 'application/json;charset=utf-8'
        },
        data: data
    })
}